export const getJobEvaluationState = () => ({
	mainData: {},
	supplies: {
		guidelineModel: {
			hasInformationJobEvaluation: false,
			informationJobEvaluation: {},
			hasPreviewValues: false,
			verbsSelection: {
				highCommand: {},
				mediumCommand: {},
				lowCommand: {},
			},
			levelSelection: {
				role: {},
				title: {},
				experience: {},
				englishLevel: {},
				quantityPerson: 0,
			},
			hierarchyAssignation: [],
			organizationChart: [],
			groups: [], // Campo para almacenar grupos centralizadamente
			userForm: {
				jobList: [],
				filteredJobs: [],
				deletedJobs: [],
				idsFilterJobs: null,
			},
		},
		valuationModel: {
			factorList: [],
			degreesListByFactor: {},
			selectedFactors: [],
			weighing: {
				selectedFactor: {},
				combinations: [],
			},
			degree: {
				selectedFactor: {},
				factorDegrees: {},
			},
		},
		generalData: {
			platforms: {},
		},
	},
});

export default getJobEvaluationState();



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/state.js